<script>
  import { urlServeur } from "../components/conf.js";

  let promise;
  let salariesActifs = 0;
  let tab_annees = {};
  let les_annees = {};

  export let annee;

  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api_employe/mouvmt_effectif/annee/" + annee
    );
    if (response.ok) {
      const res = await response.json();
      //console.log(res.payload.anciennete);

      salariesActifs = res.payload.salariesActifs;
      les_annees = res.payload.annees;
      tab_annees = res.payload.tab_annees;

      return res.payload.anciennete;
    } else {
      throw new (Error(text))();
    }
  };

  promise = fetchData();
</script>

{#await promise}
  ... wait
{:then elements}
  <h4>Mouvements des effectifs par années</h4>
  <table class="table table-responsive table-success">
    <thead>
      <tr>
        <td />
        {#each Object.entries(les_annees) as [keyAnnee]}
          <td>{keyAnnee}</td>
        {/each}
      </tr>
    </thead>

    <tbody>
      {#each Object.entries(tab_annees) as [keyTabAnnee, valueTabAnnee]}
        <tr>
          <td> {keyTabAnnee}</td>
          {#each Object.entries(valueTabAnnee) as [keyValeurTabAnnee, valueValeurTabAnnee]}
            <td>{valueValeurTabAnnee}</td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>

  <h4>Nbre de salariés par poste</h4>
  <table class="table table-responsive table-success">
    <thead>
      <tr>
        <td>Poste</td>
        <td>Nbre</td>
        <td>Age</td>
        <td>Anc.</td>
      </tr>
    </thead>
    <tbody>
      {#each Object.entries(elements) as [key, value]}
        {#if "nbre" in value == true}
          <tr>
            <td> {key}</td>
            <td>{value.nbre}</td>
            <td>{value.age}</td>
            <td>{value.ancien}</td>
          </tr>
        {/if}
      {/each}
      <tr>
        <td>Total</td>
        <td>{salariesActifs}</td>
        <td colspan="2" />
      </tr>
    </tbody>
  </table>
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
</style>
